import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import { USER_INFO, ENHANCE_PRE } from './mutation-types'

Vue.use(Vuex)

// var store = {
// 	debug: true,
// 	state: {
// 		message: 'Hello!',
// 		workshopViewJT: {},
// 	},
// 	setMessageAction(newValue) {
// 		if (this.debug) console.log('setMessageAction triggered with', newValue)
// 		this.state.message = newValue
// 	},
// 	clearMessageAction() {
// 		if (this.debug) console.log('clearMessageAction triggered')
// 		this.state.message = ''
// 	},
// 	/**
// 	 * 设置车间看板详情的机台信息。
// 	 * @param {*} value
// 	 */
// 	setWorkshopViewJT(value) {
// 		this.state.workshopViewJT = value
// 	},
// }

export default new Vuex.Store({
	modules: {
		app,
		user,
		permission,
	},
	state: {},
	mutations: {},
	actions: {},
	getters: {
		device: state => state.app.device,
		theme: state => state.app.theme,
		color: state => state.app.color,
		token: state => state.user.token,
		avatar: state => {
			state.user.avatar = Vue.ls.get(USER_INFO).avatar
			return state.user.avatar
		},
		username: state => state.user.username,
		nickname: state => {
			var userInfo = Vue.ls.get(USER_INFO)
			if (userInfo) {
				state.user.realname = Vue.ls.get(USER_INFO).realname
			} else {
				state.user.realname = 'admin'
			}

			return state.user.realname
		},
		roleCodes: state => {
			var userInfo = Vue.ls.get(USER_INFO)
			console.log('userInfo', userInfo)

			if (userInfo) {
				var value = userInfo.roleCodes
				if (value) {
					return value.substr(0, value.length - 1)
				} else {
					return ''
				}
			}

			return ''
		},
		welcome: state => state.user.welcome,
		permissionList: state => state.user.permissionList,
		userInfo: state => {
			state.user.info = Vue.ls.get(USER_INFO)
			return state.user.info
		},
		addRouters: state => state.permission.addRouters,
		enhanceJs: state => code => {
			state.enhance.enhanceJs[code] = Vue.ls.get(ENHANCE_PRE + code)
			return state.enhance.enhanceJs[code]
		},
		/**
		 * 当前用户所属车间。
		 * @param {*} state
		 */
		userWorkshopId(state) {
			var userInfo = Vue.ls.get(USER_INFO)
			if (userInfo) {
				return userInfo.workshopId
			}

			return undefined
		},
	},
})
